import React from 'react';
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { ThemeProvider } from "@material-ui/core/styles";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom';

import CompanyDetail from './Pages/CompanyDetail/index.js';
import theme from "./Theme";
import ScrollToTop from "./Components/ScrollToTop";

import Home from './Pages/Home/index.js';
import FullscreenTable from './Pages/Home/FullscreenTable.js';
import Blog from './Pages/Home/Blog.js';

import ProtectedRoute from './Routes/ProtectedRoute';
import Admin from './Pages/Admin/AdminHome';
import SignUp from './Pages/Admin/SignUp';
import SignIn from './Pages/Admin/SignIn';
import AuthProvider from './Auth/AuthProvider';


export default function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <ThemeProvider theme={theme}>
            <div className="App">
              <Switch>
                <Route path="/company/:companyName">
                  <CompanyDetail />
                </Route>
                <Route path="/table">
                  <FullscreenTable fullscreen />
                </Route>
                <Route path="/blog">
                  <Blog />
                </Route>               
                <ProtectedRoute path="/admin">
                  <Admin />
                </ProtectedRoute>
                <Route path="/signup">
                  <SignUp />
                </Route>   
                <Route path="/login">
                  <SignIn />
                </Route>                               
                <Route path="/">
                  <Home />
                </Route>
                <Redirect path="*" to="/" />
              </Switch>
            </div>
          </ThemeProvider>
        </MuiPickersUtilsProvider>
      </Router>
    </AuthProvider>
  )
}